// (C) Copyright 2026 Dassault Systemes SE.  All Rights Reserved.

import React, { useState, useRef, useLayoutEffect, ReactNode } from "react";
import { TFunction } from "i18next";

type MoreDivProps = {
  children: ReactNode;
  maxHeight: number;
  t: TFunction;
};

export default function MoreDiv({ children, maxHeight, t }: MoreDivProps) {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const element = contentRef.current;
    if (element) {
      const overflowing = element.scrollHeight > element.clientHeight;
      setIsOverflowing(overflowing);
      if (!overflowing) {
        element.style.maxHeight = "none";
      }
    }
  }, [children, maxHeight]);

  return (
    <div>
      <div
        ref={contentRef}
        style={{
          maxHeight: isExpanded ? "none" : String(maxHeight) + "px",
          overflow: "hidden",
        }}
      >
        {children}
      </div>
      {isOverflowing && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            background: "none",
            border: "none",
            color: "blue",
            cursor: "pointer",
            padding: 0,
            boxShadow: "none",
          }}
        >
          {isExpanded ? t("text.less") : t("text.more")}
        </button>
      )}
    </div>
  );
}
